import * as React from 'react';
import styled from 'styled-components';
import icon_search from './icon_search.svg';
import icon_close from './icon_close.svg';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  value: string;
  onChangeInput: (value: string) => void;
}

export const DocSelInput = ({ value, onChangeInput, ...props }: Props) => {
  return (
    <Body {...props}>
      <InputWrap>
        <InputDiv>
          <Icon src={icon_search} />
          {value && <IconClose src={icon_close} onClick={() => onChangeInput('')} />}
          <Input value={value} onChange={(e) => onChangeInput(e.target.value)} autoFocus />
        </InputDiv>
      </InputWrap>
    </Body>
  );
};

const InputWrap = styled.div`
  display: flex;
  gap: 0.8rem;
`;

const InputDiv = styled.div`
  position: relative;
  flex-grow: 1;
`;
const Icon = styled.img`
  position: absolute;
  top: 50%;
  left: 0.6rem;
  transform: translateY(-50%);
`;

const IconClose = styled.img`
  position: absolute;
  top: 50%;
  right: 0.6rem;
  transform: translateY(-50%);
`;

const Input = styled.input`
  width: 100%;
  height: 3.8rem;
  border: 1px solid #c7d6ea;
  border-radius: 0.4rem;
  padding: 0 3.8rem;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;
